/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_Material_DeleteInputs */



/**
* | output |
* | --- |
* | "Delete note" |
*
* @param {Meeting_Report_Material_DeleteInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_material_delete = /** @type {((inputs?: Meeting_Report_Material_DeleteInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_Material_DeleteInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Notitie verwijderen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer la note")
	return /** @type {LocalizedString} */ ("Delete note")
});